<template>
  <div class="loadercontainer">
    <div class="loader"></div>
    <br />
    <span>{{ text }}</span>
  </div>
</template>
<script>
export default {
  name: 'XVwaiter',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.loadercontainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 50vh;
}
.loader {
  width: 70px;
  height: 70px;
  background: none;
  border-radius: 50%;
  box-sizing: border-box;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
  -webkit-animation: spin 1.2s linear infinite;
  animation: spin 1.2s linear infinite;
}
.loader:first-child {
  margin-left: 0;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* kleuren staan in clientskin */
</style>
